import { sharedWritable } from '@chasi/manager/client/shared'

export const header = sharedWritable<CDLHeader>('header')
export const footer = sharedWritable<CDLFooter>('footer')
